<template>
  <v-expansion-panel-header style="padding: 0px 24px 0px 0px;">
    <div class="cotacao">
      <img :src="'data:image/png;base64, ' + img" />
      <h3>
        {{nome}}
        <br />
        <span>{{preco}}</span>
      </h3>
    </div>
    <template v-slot:actions>
      <v-icon small left>fa-chevron-down</v-icon>
    </template>
  </v-expansion-panel-header>
</template>

<script>
/* eslint-disable */
export default {
  props: ["img", "nome", "preco"],
};
</script>

<style scoped>
img {
  object-fit: scale-down !important;
}
</style>